import React, { useState, useEffect } from "react";
import Package from "./Package";

import { getCategories } from "../../api/categoryApi";
import { Formik, Field } from "formik";
import ErrorMessage from "../ErrorMessage";
import * as yup from "yup";
import { passCsrfToken, subDays, addDays, ifNotZero } from "../../helpers";
import { connect } from "react-redux";
import history from "../../history";
import { Container, Segment, Dropdown } from "semantic-ui-react";
import { Button, ButtonGroup } from "react-bootstrap";
import {
  Counter,
  IconInput,
  Loading as LoadingScreen,
  DatePicker,
} from "../shared";
import SemanticDatepicker from "react-semantic-ui-datepickers";
import "react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css";
import { Input, Form, TextArea } from "semantic-ui-react";
import moment from "moment";
import ReactDOM from "react-dom";
import {
  createInquiry,
  updateInquiry,
  showInquiry,
} from "../../api/inquiryApi";
import {
  phoneValidate,
  textValidate,
  alphaNumericValidate,
  numberValidate,
} from "../../helpers";
import AddonForm from "./AddonForm";
import { formatMoneyLegacy } from "../../utils/currency";

const InquiryForm = (props) => {
  const { countries, inquiry, aPackage, currentUser } = props;
  const cc = aPackage?.currency_code || 'NPR';
  const [pricing, setPricing] = useState({
    base_price: 0,
    addon_price: 0,
  });
  const [addon_price, setAddonPrice] = useState(0);
  const [searching, setSearching] = useState(false);

  useEffect(() => {
    const base = (inquiry.activity_id && inquiry.activity && typeof inquiry.activity.price === 'number')
      ? inquiry.activity.price
      : (Number(aPackage?.offer_price) || Number(aPackage?.price) || 0);
    setPricing({
      ...pricing,
      base_price: base,
      addon_price: 0,
    });
    setAddonPrice(getAddonPrice(inquiry.addons || []));
  }, [inquiry, aPackage]);

  const idToAddonMap = (addons) => {
    var hash = {};
    for (var k in addons) {
      hash[addons[k].id] = addons[k];
    }
    return hash;
  };

  const getTotalPrice = () => {
    return pricing.base_price + addon_price;
  };

  const getAddonPrice = (addons) => {
    return addons.reduce(
      (total, addon) => total + addon.price * addon.count,
      0
    );
  };

  const InquiriesSchema = yup.object().shape({
    email_address: yup.string().email().required("Required"),
    phone: phoneValidate(yup).required("Required"),
    preferred_date: yup.date().required("Required"),
    number_of_adult: yup.number().min(1, "At least 1 adult required").required("Required"),
    number_of_child: yup.number().min(0, "Must be 0 or more").required("Required"),
    activity_id: (aPackage.activities && aPackage.activities.length > 0)
      ? yup.string().required("Required")
      : yup.string(),
    nationality: yup.string(),
    address: yup.string(),
    city: yup.string(),
    zip_code: numberValidate(yup),
  }).test('travellers', 'Please add name and nationality for each traveller', function(obj) {
    const total = (obj.number_of_adult || 0) + (obj.number_of_child || 0);
    if (total < 1) return true;
    const t = obj.travellers || [];
    if (t.length < total) return false;
    return t.slice(0, total).every((x) =>
      x && (x.name || '').trim() !== '' && (x.nationality || '').trim() !== ''
    );
  });

  const totalTravellers = Math.max((inquiry.number_of_adult || 1) + (inquiry.number_of_child || 0), 1);
  const inquiryDetails = {
    ...inquiry,
    number_of_adult: Math.max(1, inquiry.number_of_adult || 0),
    number_of_child: inquiry.number_of_child ?? 0,
    contact_person_index: 0,
    email_address: inquiry.email_address || (currentUser && currentUser.email) || "",
    phone: (inquiry.phone || "").replace(/\s/g, ""),
    nationality: inquiry.nationality || "",
    preferred_date:
      inquiry.preferred_date == null
        ? new Date()
        : new Date(inquiry.preferred_date),
    package_id: aPackage.id,
    activity_id: inquiry.activity == undefined ? "" : inquiry.activity.id,
    travellers: Array.from({ length: totalTravellers }, (_, i) => {
      const src = inquiry.travellers || [];
      const el = src[i] ? { ...src[i] } : { name: "", nationality: "" };
      if (i === 0 && !(el.name || "").trim() && inquiry.head_traveller_name) el.name = inquiry.head_traveller_name;
      return el;
    }),
  };

  return (
    <div className="inquiry-page">
      <div className="container">
        <div className="inquiry-form-card">
          <Formik
        enableReinitialize
        initialValues={inquiryDetails}
        validationSchema={InquiriesSchema}
        validateOnMount
        onSubmit={(values, { setSubmitting }) => {
          values.package_id = inquiryDetails.package_id;
          const ci = values.contact_person_index ?? 0;
          const contact = (values.travellers || [])[ci];
          const parts = (contact?.name || "").trim().split(/\s+/);
          values.first_name = parts[0] || "";
          values.last_name = parts.slice(1).join(" ") || "";
          values.head_traveller_name = contact?.name || "";
          setSearching(true);
          if (inquiry.id != null) {
            updateInquiry(inquiry.idx, values)
              .then((response) => {
                setSubmitting(false);
                swal({
                  title: "Inquiry updated!",
                  text: response.data.message,
                  icon: "success",
                  button: "Continue",
                }).then(() => {
                  history.push(`/admin/inquiries`);
                });
              })
              .catch((error) => {
                setSubmitting(false);
                const msg = (error?.response?.data?.errors || [])?.join?.(" ") || error?.response?.data?.message || error?.message || "Update failed";
                swal({ title: "Error", text: msg, icon: "error" });
              });
          } else {
            createInquiry(values)
              .then((response) => {
                setSubmitting(false);
                swal({
                  title: "Yayy!! Your enquiry has been Processed. We will get back to you asap with the Confirmation!!",
                  text: response.data.message,
                  icon: "success",
                  button: "Continue",
                }).then(() => {
                  history.push("/");
                });
              })
              .catch((error) => {
                setSubmitting(false);
                const msg = (error?.response?.data?.errors || [])?.join?.(" ") || error?.response?.data?.message || error?.message || "Submission failed";
                swal({ title: "Error", text: msg, icon: "error" });
              });
          }
        }}
      >
        {({
          values,
          status,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          isValid,
          setFieldValue,
        }) => (
          <div className="inquiry-form">
            <form onSubmit={handleSubmit}>
              {/* Header: Package name + Total price */}
              <div className="inquiry-form__header">
                <div className="inquiry-form__header-inner">
                  <div className="inquiry-form__title-wrap">
                    <h1 className="inquiry-form__package-name">{aPackage?.name || "Tour"}</h1>
                    <span className="inquiry-form__subtitle">Inquiry</span>
                  </div>
                  <div className="inquiry-form__price-card">
                    <div className="inquiry-form__price-total">{formatMoneyLegacy(getTotalPrice(), cc)}</div>
                    <div className="inquiry-form__price-detail">Base: {formatMoneyLegacy(pricing.base_price, cc)}{addon_price > 0 ? ` · +${formatMoneyLegacy(addon_price, cc)} addons` : ""}</div>
                  </div>
                </div>
              </div>

              {Object.keys(errors).length > 0 && (
                <div className="alert alert-danger py-2 mb-2" role="alert">
                  Please fix the errors below.
                </div>
              )}

              {/* Two columns: Left = date & travellers | Right = contact */}
              <div className="row mx-0">
                {/* LEFT: Preferred date, Number of travellers, traveller list, Activity, addons */}
                <div className="col-12 col-lg-6 mb-3 mb-lg-0">
                  <div className="input-section padded input-section--trip h-100">
                    {aPackage.activities && aPackage.activities.length > 0 && (
                      <div className="field-box mb-2">
                        <label>Select Activity</label>
                        <Dropdown
                          name="activity_id"
                          placeholder="Select activities"
                          onBlur={handleBlur}
                          clearable
                          onChange={(e, data) => {
                            if (data.value) {
                              var activity = aPackage.activities.find((v) => v.id == data.value);
                              setPricing({ ...pricing, base_price: activity.price });
                              setFieldValue(`activity`, activity);
                            } else {
                              setPricing({ ...pricing, base_price: aPackage.price });
                              setFieldValue(`activity`, {});
                            }
                            setFieldValue(`activity_id`, data.value);
                          }}
                          value={values.activity_id}
                          fluid
                          search
                          selection
                          options={aPackage.activities.map((a) => ({ key: a.id, value: a.id, text: a.description })).prepend({ key: "", value: "", text: "None" })}
                        />
                        <ErrorMessage name="activity_id" />
                      </div>
                    )}
                    <div className="field-box mb-2">
                      <label className="d-block">Preferred date</label>
                      <DatePicker
                        name="preferred_date"
                        className="w-100"
                        type="date"
                        date={values.preferred_date}
                        minDate={new Date()}
                        maxDate={addDays(new Date(), 365)}
                        onBlur={handleBlur}
                        onChange={(date) => setFieldValue("preferred_date", date)}
                        value={values.preferred_date}
                        placeholder="Arrival Date"
                      />
                      <ErrorMessage name="preferred_date" />
                    </div>

                    <div className="field-box mb-2">
                      <label className="d-block">Number of Travellers (Adult, Child)</label>
                      <Dropdown
                          name=""
                          placeholder="Select traveller"
                          icon="users"
                          className="icon btn-dropdown travellers"
                          iconPosition="left"
                          fluid
                          selection
                          closeOnChange={false}
                          placeholder={
                            "Adult".pluralize(values.number_of_adult) +
                            ifNotZero(
                              values.number_of_child,
                              `, ${"Child".pluralize(
                                values.number_of_child,
                                "ren"
                              )}`
                            )
                          }
                          onClick={(event, data) => {
                            event.preventDefault();
                          }}
                        >
                          <Dropdown.Menu
                            onClick={(e, data) => {
                              e.stopPropagation();
                              e.preventDefault();
                            }}
                            content={
                              <div className="p-2">
                                <Counter
                                  id="number_of_adult"
                                  type="number"
                                  className="m-1"
                                  min={1}
                                  onBlur={handleBlur}
                                  title={`Adult`.pluralize(
                                    values.number_of_adult
                                  )}
                                  onChange={(value) => {
                                    setFieldValue("number_of_adult", value);
                                    const total = value + (values.number_of_child || 0);
                                    const prev = values.travellers || [];
                                    const next = Array.from({ length: total }, (_, i) =>
                                      prev[i] ? { ...prev[i] } : { name: "", nationality: "" }
                                    );
                                    setFieldValue("travellers", next);
                                  }}
                                  value={values.number_of_adult}
                                />
                                <Counter
                                  id="number_of_child"
                                  type="number"
                                  className="m-1"
                                  onBlur={handleBlur}
                                  title={"Child".pluralize(
                                    values.number_of_child,
                                    "ren"
                                  )}
                                  onChange={(value) => {
                                    setFieldValue("number_of_child", value);
                                    const total = (values.number_of_adult || 0) + value;
                                    const prev = values.travellers || [];
                                    const next = Array.from({ length: total }, (_, i) =>
                                      prev[i] ? { ...prev[i] } : { name: "", nationality: "" }
                                    );
                                    setFieldValue("travellers", next);
                                  }}
                                  value={values.number_of_child}
                                />
                              </div>
                            }
                          />
                        </Dropdown>
                        {/* <ErrorMessage name='number_of_adult' />
												<ErrorMessage name='number_of_child' /> */}
                        {errors.number_of_adult && (
                          <span className="ui tiny red header">
                            {errors.number_of_adult}
                          </span>
                        )}
                        {errors.number_of_child && (
                          <span className="ui tiny red header">{errors.number_of_child}</span>
                        )}
                    </div>

                    <div className="mb-2">
                      {(values.travellers || []).map((t, i) => (
                        <div key={i} className="row mx-0 mb-2">
                          <div className="col-12 col-md-6 pl-0 pr-2 text-left">
                            <div className="field-box mb-2">
                              <label className="d-block text-left">Traveller {i + 1} – Name</label>
                              <Form.Input
                                fluid
                                placeholder="Full name"
                                value={(values.travellers || [])[i]?.name || ""}
                                onChange={(e) => {
                                  const next = [...(values.travellers || [])];
                                  if (!next[i]) next[i] = { name: "", nationality: "" };
                                  next[i] = { ...next[i], name: e.target.value };
                                  setFieldValue("travellers", next);
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-12 col-md-6 pl-1 pl-md-2">
                            <div className="field-box mb-2">
                              <label className="d-block">Traveller {i + 1} – Nationality <span className="text-danger">*</span></label>
                              <Form.Input
                                fluid
                                placeholder="e.g. Nepal, USA, UK"
                                value={(values.travellers || [])[i]?.nationality || ""}
                                onChange={(e) => {
                                  const next = [...(values.travellers || [])];
                                  if (!next[i]) next[i] = { name: "", nationality: "" };
                                  next[i] = { ...next[i], nationality: e.target.value };
                                  setFieldValue("travellers", next);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                      {errors.travellers && (
                        <span className="ui tiny red header d-block mb-1">{errors.travellers}</span>
                      )}
                    </div>
                    {values.addons && values.addons.length > 0 && (
                      <table className="table table-sm table-bordered mt-2">
                        <thead><tr><th>Addon</th><th>Price</th><th>Count</th></tr></thead>
                        <tbody>
                          {values.addons.map((v, i) => (
                            <tr key={v.id || v.idx || i}><td>{v.name}</td><td>{formatMoneyLegacy(v.price, cc)}</td><td>{v.count}</td></tr>
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>

                {/* RIGHT: Contact */}
                <div className="col-12 col-lg-6 pl-lg-3 mb-3 mb-lg-0">
                  <div className="input-section padded input-section--contact h-100">
                  {(values.travellers || []).length > 1 && (
                    <div className="field-box mb-2">
                      <label className="d-block">Who is the contact person?</label>
                          <Form.Select
                            fluid
                            selection
                            options={(values.travellers || []).map((t, i) => {
                              const name = (t.name || "").trim();
                              return { key: i, value: i, text: name ? `Traveller ${i + 1}: ${name}` : `Traveller ${i + 1}` };
                            })}
                            value={values.contact_person_index ?? 0}
                            onChange={(e, data) => setFieldValue("contact_person_index", data.value)}
                            placeholder="Select contact person"
                          />
                    </div>
                  )}
                  <div className="field-box mb-2">
                    <label className="d-block">Contact Email <span className="text-danger">*</span></label>
                        <Form.Input
                          fluid
                          name="email_address"
                          type="email"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.email_address}
                          placeholder="Email Address"
                        />
                    {errors.email_address && <span className="ui tiny red header">{errors.email_address}</span>}
                  </div>
                  <div className="field-box mb-2">
                    <label className="d-block">Contact WhatsApp / Mobile <span className="text-danger">*</span></label>
                        <Input
                          fluid
                          name="phone"
                          onBlur={handleBlur}
                          onChange={(e) => setFieldValue("phone", (e.target.value || "").replace(/\s/g, ""))}
                          value={values.phone}
                          placeholder="e.g. +9779812345678 or +44987654321"
                        />
                    {errors.phone && <span className="ui tiny red header">{errors.phone}</span>}
                  </div>
                  {/* City, Country, Address – not required; commented out
                  <div className="row mb-3">
                    <div className="col-12 col-md-6">
                      <div className="field-box">
                        <label className="d-block">City <span className="text-danger">*</span></label>
                        <Form.Input fluid name="city" onBlur={handleBlur} onChange={handleChange} value={values.city} placeholder="City" />
                        {errors.city && <span className="ui tiny red header">{errors.city}</span>}
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
                      <div className="field-box">
                        <label className="d-block">Country (optional)</label>
                        <Form.Input fluid name="nationality" onBlur={handleBlur} onChange={handleChange} value={values.nationality} placeholder="e.g. Nepal, USA" />
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-12">
                      <div className="field-box">
                        <label className="d-block">Address (optional)</label>
                        <Form.Input fluid name="address" onBlur={handleBlur} onChange={handleChange} value={values.address} placeholder="Address" />
                      </div>
                    </div>
                  </div>
                  */}
                  <div className="field-box">
                    <label className="d-block">Special Request <span className="text-muted small font-weight-normal">(optional)</span></label>
                    <TextArea
                      className="form-control"
                      name="query"
                      placeholder="Any special request or query?"
                      onBlur={handleBlur}
                      onChange={(e) => setFieldValue("query", e.target.value)}
                      value={values.query}
                      rows={3}
                    />
                  </div>
                  </div>
                </div>
              </div>

              {/* Submit - centered */}
              <div className="row mt-4 mb-3">
                <div className="col-12 text-center">
                  <button className="inquiry-form__submit btn btn-primary btn-lg px-5" type="submit" disabled={isSubmitting || !isValid}>
                    {isSubmitting ? "Sending…" : (inquiry.id ? "Update inquiry" : "Submit inquiry")}
                  </button>
                </div>
              </div>
            </form>
          </div>
        )}
      </Formik>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ extras, userStore }) => ({
  countries: extras.countries,
  currentUser: userStore.currentUser || {},
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(InquiryForm);
